import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { DlgDecorationComponent } from './dlg-decoration';

@Injectable()
export class ShowDlgDecorationService {
    constructor(
        private _dialog: MatDialog,
    ) {
    }

    showDialog(data: any): MatDialogRef<DlgDecorationComponent> {
        if (!data.hasOwnProperty('showDescriptionContent')) {
            data.showDescriptionContent = true;
        }

        return this._dialog
            .open(DlgDecorationComponent, {
                backdropClass: 'mat-backdrop--long-scroll',
                panelClass: ['--ui'],
                data
            });
    }
}
